// Zoom 接続結果の画面（/user/connect_zoom_account）で、サーバーから渡された結果を読み、
// アプリへ送る知らせを決める（NP-USR-BUG-025）。
// 画面の部品から切り離して、node --test で試せるようにしている。

const USER_KEYS = [
  'id', 'name', 'account_name', 'email', 'nb_id', 'nb_author_id', 'nb_organization_id',
  'narrative_phone_id', 'ios_zoom_available', 'android_zoom_available', 'description',
  'icon_img_path', 'state', 'state_jp'
]

const DEVICE_KEYS = [
  'id', 'phone_device_id', 'phone_device_description', 'phone_device_token',
  'device_authenticate_token', 'push_target', 'created_at', 'available'
]

function parseJSON (text) {
  if (typeof text !== 'string' || text.length === 0) {
    return null
  }
  try {
    const value = JSON.parse(text)
    return value && typeof value === 'object' ? value : null
  } catch (e) {
    return null
  }
}

function pick (source, keys) {
  const out = {}
  keys.forEach(key => { out[key] = source[key] })
  return out
}

// サーバーは端末の情報を `device` の名前で渡す。以前の Web は `phone_device` を読んでいて、
// 端末の情報が入らなかった。古い名前も読めるようにしておく。
export function parseConnectQuery (query) {
  const q = query || {}
  const user = parseJSON(q.user)
  const device = parseJSON(q.device) || parseJSON(q.phone_device)
  return {
    result: typeof q.result === 'string' ? q.result : '',
    type: typeof q.type === 'string' ? q.type : '',
    user: user ? pick(user, USER_KEYS) : {},
    device: device ? pick(device, DEVICE_KEYS) : {}
  }
}

// アプリへ送る知らせ。null なら送らない。
// 以前は「Zoom が使える」ときにしか送っておらず、失敗のときはアプリに何も届かなかった。
export function finishedEvent ({ result, user }) {
  const u = user || {}
  const available = Boolean(u.ios_zoom_available || u.android_zoom_available)
  if (result === 'success' && available) {
    return {
      name: 'zoomUserActivatedEvent',
      data: {
        user_id: u.id,
        narrative_phone_id: u.narrative_phone_id,
        ios_zoom_available: u.ios_zoom_available,
        android_zoom_available: u.android_zoom_available
      }
    }
  }
  if (result === 'success' || result === 'failed') {
    return { name: 'zoomUserActivationFailedEvent', data: null }
  }
  return null
}

// 成功の画面に出す端末の種類の名前
export function deviceTypeLabel (type) {
  if (type === 'ios') return 'iOS'
  if (type === 'android') return 'Android'
  return ''
}
